import React from 'react';
import { XCircle, ArrowLeft, HelpCircle, Mail, BookOpen, Calendar } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 via-white to-orange-50">
      <div className="max-w-4xl mx-auto px-4 py-20">
        {/* Cancel Icon */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-24 h-24 bg-red-100 rounded-full mb-6">
            <XCircle className="w-16 h-16 text-red-600" />
          </div>
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Payment Cancelled
          </h1>
          <p className="text-xl text-gray-600">
            Your payment was not completed
          </p>
        </div>

        {/* Message */}
        <div className="bg-white rounded-2xl shadow-lg p-8 mb-8">
          <p className="text-gray-700 text-lg text-center mb-6">
            No charges were made to your account. Your payment was cancelled before completion.
          </p>
          
          <div className="bg-blue-50 border-l-4 border-blue-500 p-6 rounded-r-lg">
            <div className="flex items-start">
              <HelpCircle className="w-6 h-6 text-blue-600 mr-3 flex-shrink-0 mt-1" />
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Need Help?</h3>
                <p className="text-gray-700 mb-4">
                  If you experienced any issues during checkout or have questions about our mentorship program:
                </p>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-center">
                    <Mail className="w-4 h-4 mr-2 text-blue-600" />
                    Email: <a href="mailto:admin@obedansuacademy.uk" className="text-blue-600 hover:underline ml-1">admin@obedansuacademy.uk</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* What You Can Do */}
        <div className="bg-white rounded-2xl shadow-lg p-8 mb-8">
          <h2 className="text-2xl font-semibold text-gray-900 mb-6">What would you like to do?</h2>
          
          <div className="grid md:grid-cols-2 gap-4">
            <button
              onClick={() => navigate('/enroll')}
              className="bg-gradient-to-r from-purple-600 to-orange-500 text-white p-6 rounded-xl text-left hover:from-purple-700 hover:to-orange-600 transition-all duration-200"
            >
              <h3 className="text-xl font-semibold mb-2">Try Again</h3>
              <p className="text-purple-100">
                Return to enrollment page and complete your payment
              </p>
            </button>

            <button
              onClick={() => navigate('/')}
              className="bg-gray-100 text-gray-900 p-6 rounded-xl text-left hover:bg-gray-200 transition-all duration-200"
            >
              <h3 className="text-xl font-semibold mb-2">Back to Home</h3>
              <p className="text-gray-600">
                Return to homepage and explore more about our academy
              </p>
            </button>
          </div>
        </div>

        {/* Additional Options */}
        <div className="grid md:grid-cols-3 gap-6">
          <button
            onClick={() => navigate('/library')}
            className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all text-center"
          >
            <BookOpen className="w-8 h-8 text-purple-600 mx-auto mb-3" />
            <h3 className="font-semibold text-gray-900 mb-2">Browse Library</h3>
            <p className="text-sm text-gray-600">Explore our ebook collection</p>
          </button>

          <button
            onClick={() => navigate('/courses')}
            className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all text-center"
          >
            <BookOpen className="w-8 h-8 text-orange-600 mx-auto mb-3" />
            <h3 className="font-semibold text-gray-900 mb-2">View Courses</h3>
            <p className="text-sm text-gray-600">See our course offerings</p>
          </button>

          <button
            onClick={() => navigate('/appointments')}
            className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all text-center"
          >
            <Calendar className="w-8 h-8 text-green-600 mx-auto mb-3" />
            <h3 className="font-semibold text-gray-900 mb-2">Book Free Q&A</h3>
            <p className="text-sm text-gray-600">Try a free session first</p>
          </button>
        </div>

        {/* Back Button */}
        <div className="text-center mt-8">
          <button
            onClick={() => navigate(-1)}
            className="text-gray-600 hover:text-gray-900 font-medium inline-flex items-center"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
